import { ref } from 'lit/directives/ref.js';

/** Native form semantics for the existing Engine fields, which do not expose these attributes yet.
 * Values, events, rendering and styling remain owned by the Engine component.
 */
export function engineFieldAttributes(options: {
  id: string;
  label: string;
  name?: string;
  required?: boolean;
  error?: string;
  type?: 'tel' | 'search';
}) {
  return ref(element => {
    if (!element) return;
    queueMicrotask(() => {
      if (!element.isConnected) return;
      const input = element.querySelector<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      if (!input) return;
      input.id = options.id;
      input.name = options.name ?? options.id;
      input.required = !!options.required;
      input.setAttribute('aria-label', options.label);
      if (options.type && input instanceof HTMLInputElement) input.type = options.type;
      if (input instanceof HTMLInputElement && input.type === 'file') {
        const trigger = element.querySelector<HTMLElement>('[tabindex="0"]');
        trigger?.setAttribute('role', 'button');
        trigger?.setAttribute('aria-label', options.label);
      }
      const error = element.querySelector<HTMLElement>('.text-error');
      const hasError = !!(options.error || error?.textContent?.trim());
      input.setAttribute('aria-invalid', String(hasError));
      if (hasError && error) {
        error.id = `${options.id}-error`;
        error.setAttribute('role', 'alert');
        input.setAttribute('aria-describedby', error.id);
      } else input.removeAttribute('aria-describedby');
    });
  });
}
